module.exports = __webpack_public_path__ + "static/media/[Keats_and_Beats]2013-02-08.5965ee50.md";